import { deleteQuery, updateQueryParam } from '@repo/shared/shared';
import { useSearchParams } from 'next/navigation';
import { useRouter } from 'next/router';

const useCart = () => {
  const router = useRouter();
  const searchParams = useSearchParams();

  const isOpen = searchParams?.get('cart') === 'open';

  const onOpen = () => {
    updateQueryParam(router, 'cart', 'open');
  };

  const onClose = () => {
    deleteQuery(router, 'cart');
  };

  return {
    isOpen,
    onOpen,
    onClose,
  };
};

export default useCart;
